'use client'

import { AccountControlCard } from '@repo/ui/AccountControlCard'
import { ClientPortalCard } from '@repo/ui/ClientPortalCard'
import { ClientProfileCard } from '@repo/ui/ClientProfileCard'
import { InvoicesCard } from '@repo/ui/InvoicesCard'
import { useClientStore } from '@repo/store/useClientStore'
import { useMenuItemsStore } from '@repo/store/useMenuItemsStore'
import { WorkspaceDetailsCard } from '@repo/ui/WorkspaceDetailsCard'
import MUIBox from '@mui/material/Box'
import MUIPaper from '@mui/material/Paper'
import MUIStack from '@mui/material/Stack'
import MUITypography from '@mui/material/Typography'

export const ClientWorkspaceModule = () => {
  const { currentClient } = useClientStore()
  const { allowedMenuIds } = useMenuItemsStore()

  return (
    <MUIStack
      data-testid="ClientWorkspaceModule"
      direction="column"
      sx={{ width: '100%', maxWidth: '1600px', margin: '0 auto 2rem', minHeight: '920px', padding: '24px 40px 40px' }}
      gap={'24px'}
    >
      {currentClient ? (
        <MUIBox
          sx={{
            display: 'grid',
            gridAutoFlow: 'column',
            gridTemplateColumns: 'repeat(3, minmax(17rem, 100%))',
            gridTemplateRows: 'repeat(3, minmax(17rem, 19rem))',
            gridGap: '24px'
          }}
        >
          <ClientProfileCard sx={{ gridArea: '1/1/2/3' }} />
          <WorkspaceDetailsCard
            isClientWorkspace
            sx={{ height: 'auto', width: '100%', minHeight: '-webkit-fill-available', gridArea: '1/3/4/4' }}
          />
          <AccountControlCard clientWorkspace={true} sx={{ height: 'auto', width: '100%', gridArea: '2/1/3/2' }} />
          <InvoicesCard sx={{ gridArea: '2/2/3/3' }} />
          {allowedMenuIds?.includes(1131) && allowedMenuIds?.includes(1134) && (
            <ClientPortalCard sx={{ gridArea: '3/1/4/3' }} />
          )}
        </MUIBox>
      ) : (
        <MUIPaper
          sx={{
            alignItems: 'center',
            background: 'white',
            border: '1px solid #D8DCE5',
            borderRadius: 1,
            boxShadow: 'none',
            display: 'flex',
            height: 'auto',
            justifyContent: 'center',
            minHeight: '5rem',
            minWidth: '100%',
            padding: '0',
            position: 'relative',
            width: '100%'
          }}
        >
          <MUITypography variant="h6" sx={{ mb: 0 }}>
            Please select a matter to view details
          </MUITypography>
        </MUIPaper>
      )}
    </MUIStack>
  )
}
